<h1><a href="/admin-home">Admin</a> - Total Dealers by Tier</h1>
<section>  
  <p>{{loading}}</p>
  <div class="report-table-container">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Tier </th>
        <td mat-cell *matCellDef="let element"> {{element.date}} </td>
      </ng-container>

      <ng-container matColumnDef="revenue">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Dealers </th>
        <td mat-cell *matCellDef="let element"> {{element.revenue.toFixed(0)}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
  <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons>
  </mat-paginator>
  <br>
</section>